import {AfterViewInit, Component, ElementRef, Input, OnInit, Optional, Self, ViewChild} from '@angular/core';
import {ControlValueAccessor, FormBuilder, FormControl, NgControl, ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldControl} from "@angular/material/form-field";
import {FieldComponent} from "@shared/component/common/fields/field.component";
import {FocusMonitor} from "@angular/cdk/a11y";
import {MatInputModule} from "@angular/material/input";
import {CommonModule, PercentPipe} from "@angular/common";
import {first, tap} from "rxjs";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {ErrorStateMatcher} from "@angular/material/core";

@UntilDestroy()
@Component({
  selector: 'app-percent-input',
  templateUrl: './percent-input.component.html',
  styleUrls: ['./percent-input.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatInputModule,
    ReactiveFormsModule,
  ],
  providers: [
    {provide: MatFormFieldControl, useExisting: PercentInputComponent},
    PercentPipe,
  ]
})
export class PercentInputComponent extends FieldComponent<number> implements OnInit, ControlValueAccessor, AfterViewInit {
  @ViewChild('input', {read: ElementRef, static: true}) input: ElementRef<HTMLElement>;

  formControl: FormControl<string> = this.fb.control('');

  get errorState(): boolean {
    return this.errorStateMatcher.isErrorState(
      this.ngControl.control as FormControl,
      null,
    );
  }

  constructor(
    @Optional() @Self() public readonly ngControl: NgControl,
    protected readonly elementRef: ElementRef,
    protected readonly focusMonitor: FocusMonitor,
    protected readonly fb: FormBuilder,
    protected readonly errorStateMatcher: ErrorStateMatcher,
    protected readonly percentPipe: PercentPipe,
  ) {
    super(ngControl, elementRef, focusMonitor);
  }

  @Input()
  set value(value: number) {
    this.formControl.setValue(this.percentPipe.transform(value,'.0-6').replace('%', ''));

    this.stateChanges.next();
  }

  ngOnInit(): void {
    super.ngOnInit()
  }

  ngAfterViewInit(): void {
    this.focusMonitor.monitor(this.input).pipe(
      first(),
      tap(() => {
        this.onTouched();
      }),
    ).subscribe();

    this.formControl.valueChanges.pipe(
      untilDestroyed(this),
      tap(value => {
        const lastValue = parseFloat(value) / 100

        this.onChange(isNaN(lastValue) ? null : lastValue)

        this.onTouched()
      })
    ).subscribe()
  }
}
